import React, { useContext, useEffect } from "react";
import {
  EllipticalROITool,
  LengthTool,
  PanTool,
  RectangleROITool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
  utilities,
} from "@cornerstonejs/tools";
import ViewportContext from "../../../context/studyviewer/ViewportContext";
import { render } from "@testing-library/react";
import { reset, eventBus } from "./CornerstoneViewportService";
import studyviewerContext from "../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../context/studyviewer/ThumbnailContext";

const ContextMenu = (props) => {
  const {
    handleRemoveBoundingBox,
    setActiveTool,
    setPreviousActiveTool,
    activeTool,
    setContextMenuOpen,
    contextMenuOpen,
    activeViewportIndex,
    annotationData,
    annotationDataAI,
    addedAnnotation,
    isMPRActive,
    setPreviousActiveMPRTool,
    activeMPRTool,
    setActiveMPRTool,
    handleChangeLabelForTextAnnotation,
    activeMPRViewportIndex,
    boundingBoxMode,
    setBoundingBoxMode,
    isCropEnable,
    setIsCropEnable,
    viewportSeriesData,
    
  } = useContext(ViewportContext);
  const { checkForMaskingAnnotation, maskImages, setMaskImages} = useContext(studyviewerContext);
  const {activeThumbnailIndex} = useContext(ThumbnailContext);
  const changeActiveTool = async (tool) => {
    // eventTarget.reset();
    if (isMPRActive) {
      setPreviousActiveMPRTool(activeMPRTool);
      setActiveMPRTool(tool);
    } else {
      const isBBMode = boundingBoxMode;
      const isCropMode =  isCropEnable;

      setIsCropEnable(false);
      setBoundingBoxMode(false);
    
    if (!isBBMode && !isCropMode && activeTool === tool) {
        setPreviousActiveTool(activeTool);
        setActiveTool(StackScrollTool.toolName);
      } else {
        setPreviousActiveTool(activeTool);
        setActiveTool(tool);
      }
    }
    setContextMenuOpen(() => {
      const newVal = { ...contextMenuOpen };
      newVal.open = false;
      newVal.mouseEvt = null;
      newVal.data = null;
      return newVal;
    });
  };

  const handleReset = async () => {
   const activeIndex =  isMPRActive ? activeMPRViewportIndex : activeViewportIndex
 
    await reset(
      activeIndex,
      annotationData,
      annotationDataAI,
      addedAnnotation,
      isMPRActive,
      maskImages,
      activeThumbnailIndex
    );
    setMaskImages(maskImages);
    setContextMenuOpen(() => {
      const newVal = { ...contextMenuOpen };
      newVal.open = false;
      newVal.mouseEvt = null;
      newVal.data = null;
      return newVal;
    });
    // TODO: reset need to discuss
    // setCropAnnotationData([]);
  };

  useEffect(() => {
    const contextMenu = document.getElementById("context-menu");

    if (!contextMenu) return;
    contextMenu.style.visibility = "hidden";
    contextMenu.style.display = "block";
    const { clientX, clientY } = props.mouseEvt;
    const menuWidth = contextMenu.offsetWidth;
    const menuHeight = contextMenu.offsetHeight;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Calculate the adjusted position
    let left = clientX;
    let top = clientY;

    // Prevent menu from going off the right edge
    if (clientX + menuWidth > screenWidth) {
      left = screenWidth - menuWidth;
    }

    // Prevent menu from going off the bottom edge
    if (clientY + menuHeight > screenHeight) {
      top = screenHeight - menuHeight;
    }

    contextMenu.style.left = `${left}px`;
    contextMenu.style.top = `${top}px`;
    contextMenu.style.visibility = "visible";
    contextMenu.classList.add("visible");
  }, [props.mouseEvt]);

  // todo : - 
  const checkForMasking= ()=>{
    return checkForMaskingAnnotation(props.data?.annotationUID) !==null;
  }
 
  return (
    <div id="context-menu">
     { !checkForMasking()&&(
        <>
      <p
        className="context-menu-tool-text"
        onClick={() => changeActiveTool(WindowLevelTool.toolName)}
      >
        Window Level Tool
      </p>
      <p
        className="context-menu-tool-text"
        onClick={() => changeActiveTool(PanTool.toolName)}
      >
        Pan Tool
      </p>
      <p
        className="context-menu-tool-text"
        onClick={() => changeActiveTool(ZoomTool.toolName)}
      >
        Zoom Tool
      </p>
      <p
        className="context-menu-tool-text"
        onClick={() => changeActiveTool(LengthTool.toolName)}
      >
        Length Tool
      </p>
      <p
        className="context-menu-tool-text"
        onClick={() => changeActiveTool(EllipticalROITool.toolName)}
      >
        Elllipse Tool
      </p>
      <p
        className="context-menu-tool-text"
        onClick={() => changeActiveTool(RectangleROITool.toolName)}
      >
        Rectangle Tool
      </p>
      
      </>)}
      <p className="context-menu-tool-text" onClick={handleReset}>
        Reset
      </p>
      {contextMenuOpen.showRemove && (
        <p
          className="context-menu-remove-text"
          onClick={() => {
            handleRemoveBoundingBox(props.data);
          }}
        >
          Remove
        </p>
      )}
      {props?.data?.metadata?.toolName == "ArrowAnnotate" && (
        <p
          className="context-menu-remove-text"
          onClick={() => {
            handleChangeLabelForTextAnnotation(props.data);
          }}
        >
          Change Label
        </p>
      )}
    </div>
  );
};

export default ContextMenu;
